document.addEventListener("DOMContentLoaded", function () {
	const toggleButton = document.querySelector(".postal-code-button__toggle");
	const popupForm = document.querySelector(".postal-code-button__content");
	const inputField = document.querySelector(".postal-code-button__content__input");
	const submitButton = document.querySelector(".postal-code-button__content__submit");
	const etaValueElement = document.querySelector(".product__shipping-info__eta-value span");
	const errorMessage = document.querySelector(".postal-code-button__content__error");
	const deliveryDataInput = document.querySelector(".delivery-data");

	function getRegionFromPostalCode(postalCode) {
		const postalPrefix = postalCode.slice(0, 1).toUpperCase();
		const provinceMapping = {
			"V": "British Columbia",
			"T": "Alberta",
			"S": "Saskatchewan",
			"R": "Manitoba",
			"M": "Ontario",
			"K": "Ontario",
			"L": "Ontario",
			"H": "Quebec",
			"G": "Quebec",
			"B": "Nova Scotia",
			"C": "Prince Edward Island",
			"A": "Newfoundland and Labrador",
			"E": "New Brunswick",
			"Y": "Yukon",
			"X": "Northwest Territories",
			"X0": "Nunavut"
		};
		const province = provinceMapping[postalPrefix];
		if (!province) {
			return null;
		}
		const provinceRegions = {
			"Western Canada": ["British Columbia", "Alberta"],
			"Central Canada": ["Saskatchewan", "Manitoba"],
			"Eastern Canada": ["Ontario", "Quebec", "Newfoundland and Labrador", "Prince Edward Island", "Nova Scotia", "New Brunswick"],
			"Northern Canada": ["Yukon", "Nunavut", "Northwest Territories"]
		};
		for (const [region, provinces] of Object.entries(provinceRegions)) {
			if (provinces.includes(province)) return region;
		}
		return null;
	}

	function parseDeliveryString(dataString) {
		const deliveryInfo = {};
		const lines = dataString.split(";").map(line => line.trim()).filter(line => line);
		lines.forEach((line) => {
			const splitIndex = line.indexOf("-");
			if (splitIndex === -1) {
				return;
			}
			const region = line.slice(0, splitIndex).trim();
			const days = line.slice(splitIndex + 1).replace("business days", "").trim();
			const daysRange = days.split("-").map(Number);
			if (daysRange.length === 2 && !isNaN(daysRange[0]) && !isNaN(daysRange[1])) {
				deliveryInfo[region] = { minDays: Math.min(daysRange[0], daysRange[1]), maxDays: Math.max(daysRange[0], daysRange[1]) };
			}
		});
		return deliveryInfo;
	}

	function formatDeliveryRange(minDate, maxDate) {
		if (isNaN(minDate.getTime()) || isNaN(maxDate.getTime())) {
			return "Invalid delivery range.";
		}
		const options = { month: "short", day: "numeric" };
		return `${minDate.toLocaleDateString("en-US", options)} - ${maxDate.toLocaleDateString("en-US", options)}`;
	}

	function getTransitRegionKey(postalCode) {
		const prefix = postalCode.slice(0, 1).toUpperCase();
		if (prefix === 'V') return 'west';
		if (prefix === 'T') return 'local';
		if (prefix === 'S' || prefix === 'R') return 'central';
		return 'east';
	}

	function getVariantId() {
		const urlParams = new URLSearchParams(window.location.search);
		const urlVariant = urlParams.get("variant");
		if (urlVariant) return urlVariant;

		const productShippingInfo = document.querySelector(".product__shipping-info");
		if (productShippingInfo) {
			return productShippingInfo.getAttribute("data-var");
		}
		return null;
	}

	function validatePostalCode(postalCode) {
		const regex = /^[A-Z]\d[A-Z] \d[A-Z]\d$/i;
		return regex.test(postalCode);
	}

	const deliveryData = {
		"In Stock": parseDeliveryString(deliveryDataInput?.dataset.deliveryStock || "")
	};

	function getDeliveryDateRange(postalCode, deliveryType) {
		const region = getRegionFromPostalCode(postalCode);
		if (!region || !deliveryType) {
			return null;
		}
		const deliveryInfo = deliveryData[deliveryType]?.[region];
		if (!deliveryInfo) {
			return null;
		}

		const now = new Date();
		const minDeliveryDate = new Date(now);
		minDeliveryDate.setDate(now.getDate() + deliveryInfo.minDays);
		const maxDeliveryDate = new Date(now);
		maxDeliveryDate.setDate(now.getDate() + deliveryInfo.maxDays);
		if (isNaN(minDeliveryDate.getTime()) || isNaN(maxDeliveryDate.getTime())) {
			return null;
		}

		if (deliveryType === "Transit" && window.variantMetaData) {
			const variantId = getVariantId();
			const customDate = window.variantMetaData?.[variantId]?.custom_date;
			if (customDate) {
				return customDate;
			}
		}

		return formatDeliveryRange(minDeliveryDate, maxDeliveryDate);
	}

	// This is the function that updates dates in the cart drawer.
	// Exposed on window so it can be called again after the cart drawer re-renders.
	function updateCartDeliveryInfo() {
		if (!window.theme?.strings?.deliveryDates) return;
		const postalCode = localStorage.getItem("postalCode");
		const deliveryInfoElements = document.querySelectorAll('.delivery-info');
		const strings = window.theme.strings.deliveryDates;

		deliveryInfoElements.forEach((el) => {
			const span = el.querySelector('span');
			if (!span) return;

			// No postal code yet — show a clickable prompt instead of a random date.
			if (!postalCode) {
				span.textContent = "Enter your postal code";
				span.classList.add("delivery-info__enter-zip");
				span.style.textDecoration = "underline";
				span.style.cursor = "pointer";
				return;
			}
			span.classList.remove("delivery-info__enter-zip");
			span.style.textDecoration = "";
			span.style.cursor = "";

			const variantId = el.getAttribute('data-var');
			// Read delivery type straight from the cart HTML (data attribute),
			// set server-side by Liquid for THIS item — works regardless of
			// which product page the cart drawer happens to be opened on.
			const deliveryType = el.dataset.deliveryType || window.variantMetaData?.[variantId]?.type;
			if (!variantId || !deliveryType) {
				return;
			}
			// If a custom delivery date is set on the variant, it always wins.
			const customDate = el.dataset.customDate;
			if (customDate) {
				span.textContent = customDate;
				return;
			}
			const regionKey = getTransitRegionKey(postalCode);

			if (deliveryType === "Pre Order") {
				span.textContent =
					(regionKey && strings['delivery_date_preorder_' + regionKey])
					|| strings.delivery_date_preorder
					|| "Pre order delivery";
				return;
			}

			if (deliveryType === "Transit") {
				span.textContent =
					(regionKey && strings['delivery_date_transit_' + regionKey])
					|| strings.delivery_date_transit
					|| "Transit delivery";
				return;
			}

			const range = getDeliveryDateRange(postalCode, deliveryType);
			if (range) {
				span.textContent = range;
			}
		});
	}
	window.updateCartDeliveryInfo = updateCartDeliveryInfo;

	// Popup for entering the postal code from inside the cart (works on any page,
	// not just PDP — reuses the same classes as the PDP widget so it inherits the same styling).
	let cartPostalPopupEl = null;
	function ensureCartPostalPopup() {
		if (cartPostalPopupEl) return cartPostalPopupEl;

		const popup = document.createElement('div');
		popup.id = 'cart-postal-popup';
		popup.className = 'postal-code-button__content';
		popup.style.position = 'fixed';
		popup.style.zIndex = '9999';
		popup.style.display = 'none';
		popup.style.background = '#fff';
		popup.style.border = '1px solid #e0e0e0';
		popup.style.borderRadius = '4px';
		popup.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
		popup.style.padding = '16px';
		popup.style.minWidth = '220px';
		popup.innerHTML = `
			<div class="postal-code-button__content__title" style="margin-bottom:8px;font-size:0.9em;">Enter full Postal Code</div>
			<input autocomplete="postal-code" type="text" class="postal-code-button__content__input" placeholder="e.g. V6A 4L5" style="width:100%;box-sizing:border-box;margin-bottom:8px;padding:8px;border:1px solid #ccc;border-radius:4px;" />
			<div class="postal-code-button__content__error" style="display:none;color:red;font-size:0.85em;margin-bottom:8px;"></div>
			<button type="button" class="button postal-code-button__content__submit" style="width:100%;">Update</button>
		`;
		document.body.appendChild(popup);

		const input = popup.querySelector('.postal-code-button__content__input');
		const submit = popup.querySelector('.postal-code-button__content__submit');
		const error = popup.querySelector('.postal-code-button__content__error');

		submit.addEventListener('click', () => {
			const code = input.value.trim();
			if (validatePostalCode(code)) {
				error.style.display = 'none';
				localStorage.setItem('postalCode', code);
				popup.style.display = 'none';
				// If we're on a PDP with the widget present, refresh it too.
				if (typeof etaValueElement !== 'undefined' && etaValueElement) {
					if (typeof updateToggleButtonText === 'function') updateToggleButtonText(code);
					if (typeof handleVariantChange === 'function') handleVariantChange();
				}
				updateCartDeliveryInfo();
			} else {
				error.textContent = 'Please enter a valid Canadian postal code (e.g., V6A 4L5).';
				error.style.display = 'block';
			}
		});

		cartPostalPopupEl = popup;
		return popup;
	}

	function positionPopupNear(popup, triggerEl) {
		const rect = triggerEl.getBoundingClientRect();
		const popupWidth = 220; // matches min-width above
		let left = rect.left;
		// keep popup on-screen if trigger is close to the right edge
		if (left + popupWidth > window.innerWidth - 16) {
			left = window.innerWidth - popupWidth - 16;
		}
		popup.style.top = (rect.bottom + 8) + 'px';
		popup.style.left = left + 'px';
	}

	document.addEventListener('click', (e) => {
		if (e.target.classList.contains('delivery-info__enter-zip')) {
			const popup = ensureCartPostalPopup();
			popup.querySelector('.postal-code-button__content__input').value = '';
			popup.querySelector('.postal-code-button__content__error').style.display = 'none';
			positionPopupNear(popup, e.target);
			popup.style.display = 'block';
			return;
		}
		// click outside the popup closes it
		if (cartPostalPopupEl && cartPostalPopupEl.style.display === 'block' && !cartPostalPopupEl.contains(e.target)) {
			cartPostalPopupEl.style.display = 'none';
		}
	});

	// Run once on page load, in case the cart drawer is already populated server-side.
	updateCartDeliveryInfo();

	// Watch the cart drawer for re-renders (e.g. after "Add to cart" AJAX call)
	// and refresh the delivery dates every time its content changes.
	const cartDrawerEl = document.querySelector('.cart-drawer-modal');
	if (cartDrawerEl) {
		let isUpdatingDeliveryInfo = false;
		const cartObserver = new MutationObserver(() => {
			if (isUpdatingDeliveryInfo) return; // ignore mutations we caused ourselves
			isUpdatingDeliveryInfo = true;
			updateCartDeliveryInfo();
			// release on next tick, after our own DOM writes have settled
			setTimeout(() => { isUpdatingDeliveryInfo = false; }, 0);
		});
		cartObserver.observe(cartDrawerEl, { childList: true, subtree: true });
	}

	// --- Everything below only runs on pages that have the PDP postal code widget ---
	if (!toggleButton || !popupForm || !inputField || !submitButton || !etaValueElement || !deliveryDataInput) {
		return;
	}

	const savedPostalCode = localStorage.getItem("postalCode");
	if (savedPostalCode) {
		inputField.value = savedPostalCode;
		updateToggleButtonText(savedPostalCode);
		handleVariantChange();
	}
	toggleButton.addEventListener("click", () => {
		popupForm.classList.toggle("postal-code-button__content--open");
	});

	submitButton.addEventListener("click", async (event) => {
		event.preventDefault();
		const postalCode = inputField.value.trim();
		if (validatePostalCode(postalCode)) {
			hideError();
			localStorage.setItem("postalCode", postalCode);
			updateToggleButtonText(postalCode);
			handleVariantChange();
			updateCartDeliveryInfo();
			popupForm.classList.remove("postal-code-button__content--open");
		} else {
			showError("Please enter a valid Canadian postal code (e.g., V6A 4L5).");
		}
	});

	function calculateDeliveryDate(postalCode, deliveryType) {
		const strings = window.theme.strings.deliveryDates;

		if (deliveryType === "Transit") {
			const regionKey = postalCode ? getTransitRegionKey(postalCode) : null;
			etaValueElement.textContent =
				(regionKey && strings['delivery_date_transit_' + regionKey])
				|| strings.delivery_date_transit
				|| "Transit delivery";
			return;
		}

		if (deliveryType === "Pre Order") {
			const regionKey = postalCode ? getTransitRegionKey(postalCode) : null;
			etaValueElement.textContent =
				(regionKey && strings['delivery_date_preorder_' + regionKey])
				|| strings.delivery_date_preorder
				|| "Pre order delivery";
			return;
		}

		const range = getDeliveryDateRange(postalCode, deliveryType);
		etaValueElement.textContent = range || "Delivery information unavailable.";
	}

	function handleVariantChange() {
		const postalCode = localStorage.getItem("postalCode") || "";
		const variantId = getVariantId();

		if (!variantId) {
			etaValueElement.textContent = "Delivery information unavailable.";
			updateCartDeliveryInfo();
			return;
		}

		const deliveryType = window.variantMetaData?.[variantId]?.type;
		if (!deliveryType) {
			etaValueElement.textContent = "Delivery information unavailable.";
			updateCartDeliveryInfo();
			return;
		}

		calculateDeliveryDate(postalCode, deliveryType);
		updateCartDeliveryInfo();
	}

	function updateToggleButtonText(postalCode) {
		const postalPrefix = postalCode.slice(0, 1).toUpperCase();
		const provinceMapping = {
			"V": "British Columbia",
			"T": "Alberta",
			"S": "Saskatchewan",
			"R": "Manitoba",
			"M": "Ontario",
			"K": "Ontario",
			"L": "Ontario",
			"H": "Quebec",
			"G": "Quebec",
			"B": "Nova Scotia",
			"C": "Prince Edward Island",
			"A": "Newfoundland and Labrador",
			"E": "New Brunswick",
			"Y": "Yukon",
			"X": "Northwest Territories",
			"X0": "Nunavut"
		};
		const province = provinceMapping[postalPrefix];
		toggleButton.textContent = province ? `${province}` : "Enter Postal Code";
	}

	function showError(message) {
		if (errorMessage) {
			errorMessage.textContent = message;
			errorMessage.style.display = "block";
		}
	}

	function hideError() {
		if (errorMessage) {
			errorMessage.style.display = "none";
		}
	}

	window.addEventListener("popstate", handleVariantChange);

	(function (history) {
		const pushState = history.pushState;
		const replaceState = history.replaceState;
		history.pushState = function (...args) {
			pushState.apply(history, args);
			handleVariantChange();
		};
		history.replaceState = function (...args) {
			replaceState.apply(history, args);
			handleVariantChange();
		};
	})(window.history);

	handleVariantChange();
});